<template>
  <div class="war-room-banner">
    <div class="war-room-banner__header">
      <slot name="header" />
    </div>
    <div class="war-room-banner__content">
      <slot />
    </div>
    <div v-if="$slots.footer" class="war-room-banner__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'WarRoomBanner',
});
</script>

<style scoped lang="scss">
.war-room-banner {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: var(--theme-elevation-01);

  &__header {
    padding: 8px;
    background: var(--theme-color-over-card);
    text-align: center;
    font-weight: 600;
    font-size: 13px;
    line-height: 1.54;
    color: var(--gray-50);
  }

  &__content {
    background: var(--theme-color-card);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    padding: 16px;
  }

  &__footer {
    background: var(--theme-color-card);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px 16px 16px;
  }
}
</style>
